export const getCustomNumbersFromVoucherList = (vouchers) =>
  vouchers.reduce((string, voucher) => string + `${string ? ', ' : ''}` + voucher.numberToShow, '');

export default getCustomNumbersFromVoucherList;
